import { withListsNormalization } from "./withListsNormalization.js";
import { withListsReact } from "./withListsReact.js";
import { withListsSchema } from "./withListsSchema.js";
export function withLists(schema) {
  return editor => {
    return withListsReact(withListsNormalization(withListsSchema(schema)(editor)));
  };
}